import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faRedoAlt} from '@fortawesome/pro-solid-svg-icons';
import {canResyncAsset} from '../enablers/canResyncAsset';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionResyncIcon = faRedoAlt;

/**
 * Resync asset
 * @param params
 * @returns Action
 */
export const assetActionResync = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-resync',
	cb: () => dispatcher.trigger(ASSET_EVENT.RESYNC, asset),
	enableTest: () => canResyncAsset(asset),
	icon: assetActionResyncIcon,
	get label() {
		return AssetActionLabel.RESYNC;
	},
	...params,
});

export default assetActionResync;
